import { FormattedAddress } from '../types/JourneyPlannerTypes'
import { ResolvedPlace } from './places-service'

const uniqueCompact = (obj: any) => {
  const uniCom: any = {}
  Object.keys(obj).forEach((key) => {
    const val = obj[key]

    const shouldAdd = Object.keys(uniCom).every((uKey) => {
      return val && val !== uniCom[uKey]
    })

    if (shouldAdd) uniCom[key] = val
  })

  return uniCom
}

export const parseAddressParts = (place: ResolvedPlace) => {
  const components: any = {}
  place.addressComponents.forEach((comp) => {
    comp.types.forEach((type) => {
      components[type] = comp.longText || comp.shortText
    })
  })

  let name = place.displayName
  if (!name) {
    if (components.street_number || components.route) {
      name = [components.street_number, components.route].filter((val) => !!val).join(' ')
    } else if (components.establishment) {
      name = components.establishment
    } else {
      name = components.sublocality
    }
  }

  const parts: FormattedAddress = uniqueCompact({
    name: name,
    suburb: components.sublocality,
    city: components.locality || components.administrative_area_level_1,
    country: components.country,
  })

  const postCode = components.postal_code
  if (parts.city && postCode) parts.city += ' ' + postCode
  parts.formatted = [parts.name, parts.suburb, parts.city, parts.country]
    .filter((p) => typeof p === 'string' && p.length)
    .join(', ')

  return parts
}

export const formatted = (place: ResolvedPlace) => {
  if (!place) return ''
  const parts = parseAddressParts(place)
  return parts.formatted
}

const AddressFormatter = {
  formatted,
  parseAddressParts,
}
export default AddressFormatter
